var echarts = require('echarts/lib/echarts');

require('./surface/SurfaceSeries');
require('./surface/SurfaceView');
require('./surface/surfaceLayout');

echarts.registerVisual(echarts.util.curry(
    require('./common/opacityVisual'), 'surface'
));



//////////////////
// WEBPACK FOOTER
// ./~/echarts-gl/src/chart/surface.js
// module id = 380
// module chunks = 0